import { useState } from "react"
import { homeSlidesTwo } from "../data/data"
import circle from "../images/circle.svg"

export default function HomeSlidesTwo() {
  const [cards] = useState(homeSlidesTwo)
  const [value, setValue] = useState(0)

  const { desc, desc1, info } = cards[value]

  return (
    <>
      <section className="px-5 2xl:px-0 py-10 lg:py-20 xl:max-w-6xl xl:mx-auto">
        <h2 className="text-3xl text-center text-gray-800 mb-5 lg:text-5xl uppercase">
          What is under your control
        </h2>

        <div>
          <article className="md:grid grid-cols-2 gap-10 items-center py-10 md:relative">
            <div>
              {cards.map((card, index) => (
                <article key={index}>
                  <button
                    onClick={() => setValue(index)}
                    className={`slide__two__heading block uppercase text-lg md:text-2xl my-4 md:my-6 lg:my-16 cursor-pointer font-bold text-left lg:text-3xl lg:flex lg:justify-between lg:w-full lg:items-center ${
                      index === value &&
                      "slide__two__heading__active text-xl md:text-4xl"
                    }`}
                  >
                    {card.title}
                    <div className={`horizontal__line`}></div>

                    <div
                      className={`hidden lg:block ${
                        index === value && "left__triangle"
                      }`}
                    ></div>
                  </button>
                </article>
              ))}
            </div>

            <div>
              <p className="mb-5">{desc}</p>
              <p>{desc1}</p>

              <ul className="lg:pl-8">
                {info.map((i, index) => (
                  <li
                    key={index}
                    className="flex items-start justify-start font-bold my-3 lg:text-lg"
                  >
                    <img
                      src={circle}
                      alt={circle}
                      title={circle}
                      className="mr-5 mt-1"
                    />
                    {i}
                  </li>
                ))}
              </ul>
            </div>
          </article>
        </div>
      </section>
    </>
  )
}
